var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPreviewFavourite = function SvgPreviewFavourite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 22",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6247 15.2191L10 14.7194L9.37531 15.2191L2.6247 20.6196C1.96993 21.1434 1 20.6773 1 19.8388V2C1 1.44772 1.44772 1 2 1H18C18.5523 1 19 1.44772 19 2V19.8388C19 20.6773 18.0301 21.1434 17.3753 20.6196L10.6247 15.2191Z",
    stroke: "#E60477",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPreviewFavourite);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjYyNDcgMTUuMjE5MUwxMCAxNC43MTk0TDkuMzc1MzEgMTUuMjE5MUwyLjYyNDcgMjAuNjE5NkMxLjk2OTkzIDIxLjE0MzQgMSAyMC42NzczIDEgMTkuODM4OFYyQzEgMS40NDc3MiAxLjQ0NzcyIDEgMiAxSDE4QzE4LjU1MjMgMSAxOSAxLjQ0NzcyIDE5IDJWMTkuODM4OEMxOSAyMC42NzczIDE4LjAzMDEgMjEuMTQzNCAxNy4zNzUzIDIwLjYxOTZMMTAuNjI0NyAxNS4yMTkxWiIgc3Ryb2tlPSIjRTYwNDc3IiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";